import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class LanguageInterceptorService implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const storedLanguage = typeof localStorage !== 'undefined' ? localStorage.getItem('language') : null;
    const browserLanguage = typeof navigator !== 'undefined' && navigator.language ? navigator.language.substring(0, 2) : null;
    const languageKey = storedLanguage ?? browserLanguage;

    if (request.url.indexOf('api/v') === 0 && languageKey) {
      const modifiedRequest = request.clone({
        headers: request.headers.set('Accept-Language', languageKey),
      });
      return next.handle(modifiedRequest);
    }
    return next.handle(request);
  }
}
